import React from 'react';

const FullTimeStaffPage = () => {
    return (
        <div className="staticPage">
            <h1>YCFC Staff</h1>
            <h3>Robbie Harris, Executive Director</h3>
            <p>
                Robbie has served on full time staff since 1995. He graduated
                from the University of North Carolina at Greensboro with a B.S.
                in Business Management. Robbie received his MBA from Campbell
                University. Christian camping has been very influential in his
                life as he attended Camp Willow Run as a camper from grades 3-12
                and served on summer staff. His desire is “to provide a camping
                environment in which campers learn more about a relationship
                with Jesus Christ while having fun!” Robbie and his wife,
                Kristie (also a former CWR summer staffer) are the proud parents
                of Jackson, Eli, and Thad.
            </p>
        </div>
    );
};

export default FullTimeStaffPage;



// WEBPACK FOOTER //
// ./src/pages/ycfc-staff.js